import ApexCharts from 'apexcharts';
import { Chart, registerables } from 'chart.js';

// Register Chart.js components
Chart.register(...registerables);

document.addEventListener('DOMContentLoaded', function() {
  // Monthly Activity Chart using Chart.js (CSP-friendly)
  const monthlyActivityChart = document.getElementById('monthly-activity-chart');
  if (monthlyActivityChart) {
    const activityData = JSON.parse(monthlyActivityChart.getAttribute('data-activity') || '{"months":[], "users":[], "payments":[]}');
    const isDark = document.documentElement.classList.contains('dark');

    const ctx = monthlyActivityChart.getContext('2d');
    const chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: activityData.months || [],
        datasets: [
          {
            label: 'Users Registered',
            data: activityData.users || [],
            borderColor: '#1C64F2',
            backgroundColor: function(context) {
              const ctx = context.chart.ctx;
              const gradient = ctx.createLinearGradient(0, 0, 0, 320);
              gradient.addColorStop(0, 'rgba(28, 100, 242, 0.4)');
              gradient.addColorStop(1, 'rgba(28, 100, 242, 0.0)');
              return gradient;
            },
            fill: true,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 5,
            pointBackgroundColor: '#1C64F2',
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          },
          {
            label: 'New Licences',
            data: activityData.payments || [],
            borderColor: '#16BDCA',
            backgroundColor: function(context) {
              const ctx = context.chart.ctx;
              const gradient = ctx.createLinearGradient(0, 0, 0, 320);
              gradient.addColorStop(0, 'rgba(22, 189, 202, 0.4)');
              gradient.addColorStop(1, 'rgba(22, 189, 202, 0.0)');
              return gradient;
            },
            fill: true,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 5,
            pointBackgroundColor: '#16BDCA',
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          },
          {
            label: 'Renewals',
            data: activityData.renewals || [],
            borderColor: '#7E3AF2',
            backgroundColor: 'rgba(126, 58, 242, 0.0)',
            fill: false,
            tension: 0.4,
            borderWidth: 2,
            pointRadius: 0,
            pointHoverRadius: 5,
            pointBackgroundColor: '#7E3AF2',
            pointBorderColor: '#fff',
            pointBorderWidth: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false
        },
        plugins: {
          legend: {
            display: true,
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
              color: isDark ? '#9CA3AF' : '#6B7280',
              font: {
                size: 13,
                weight: 500,
                family: 'Inter, sans-serif'
              },
              padding: 15
            }
          },
          tooltip: {
            enabled: true,
            backgroundColor: isDark ? '#1F2937' : '#FFFFFF',
            titleColor: isDark ? '#F3F4F6' : '#111827',
            bodyColor: isDark ? '#D1D5DB' : '#6B7280',
            borderColor: isDark ? '#374151' : '#E5E7EB',
            borderWidth: 1,
            padding: 12,
            displayColors: true,
            callbacks: {
              label: function(context) {
                return context.dataset.label + ': ' + context.parsed.y;
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: isDark ? '#9CA3AF' : '#6B7280',
              font: {
                size: 13,
                weight: 500
              }
            },
            border: {
              color: isDark ? '#374151' : '#E5E7EB'
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: isDark ? '#374151' : '#F3F4F6',
              drawBorder: false
            },
            ticks: {
              color: isDark ? '#9CA3AF' : '#6B7280',
              font: {
                size: 13,
                weight: 500
              },
              callback: function(value) {
                return Math.floor(value);
              }
            },
            border: {
              display: false
            }
          }
        }
      }
    });

    // Update chart colors when dark mode changes
    document.addEventListener('dark-mode', function() {
      const newIsDark = document.documentElement.classList.contains('dark');
      chart.options.plugins.legend.labels.color = newIsDark ? '#9CA3AF' : '#6B7280';
      chart.options.plugins.tooltip.backgroundColor = newIsDark ? '#1F2937' : '#FFFFFF';
      chart.options.plugins.tooltip.titleColor = newIsDark ? '#F3F4F6' : '#111827';
      chart.options.plugins.tooltip.bodyColor = newIsDark ? '#D1D5DB' : '#6B7280';
      chart.options.plugins.tooltip.borderColor = newIsDark ? '#374151' : '#E5E7EB';
      chart.options.scales.x.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
      chart.options.scales.x.border.color = newIsDark ? '#374151' : '#E5E7EB';
      chart.options.scales.y.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
      chart.options.scales.y.grid.color = newIsDark ? '#374151' : '#F3F4F6';
      chart.update();
    });
  }

  // Daily Revenue Chart: new licences vs renewals, stacked
  const dailyRevenueChart = document.getElementById('daily-revenue-chart');
  if (dailyRevenueChart) {
    createStackedBarChart(dailyRevenueChart, [
      { key: 'new_licences', label: 'New Licences', color: '#16BDCA' },
      { key: 'renewals', label: 'Renewals', color: '#7E3AF2' }
    ], { money: true, rotateLabels: true });
  }

  // Expiring Kits Chart using Chart.js (bar chart, one bar per week)
  const expiringKitsChart = document.getElementById('expiring-kits-chart');
  if (expiringKitsChart) {
    const expiringData = JSON.parse(expiringKitsChart.getAttribute('data-expiring') || '{"labels":[], "counts":[]}');
    const isDark = document.documentElement.classList.contains('dark');

    const ctx = expiringKitsChart.getContext('2d');
    const chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: expiringData.labels || [],
        datasets: [
          {
            label: 'Kits Expiring',
            data: expiringData.counts || [],
            backgroundColor: '#D97706',
            borderColor: '#B45309',
            borderWidth: 1,
            borderRadius: 4,
            barPercentage: 0.6
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'index',
          intersect: false
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            backgroundColor: isDark ? '#1F2937' : '#FFFFFF',
            titleColor: isDark ? '#F3F4F6' : '#111827',
            bodyColor: isDark ? '#D1D5DB' : '#6B7280',
            borderColor: isDark ? '#374151' : '#E5E7EB',
            borderWidth: 1,
            padding: 12,
            displayColors: false,
            callbacks: {
              label: function(context) {
                return context.parsed.y + (context.parsed.y === 1 ? ' kit' : ' kits');
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              color: isDark ? '#9CA3AF' : '#6B7280',
              font: {
                size: 11,
                weight: 500
              }
            },
            border: {
              color: isDark ? '#374151' : '#E5E7EB'
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: isDark ? '#374151' : '#F3F4F6',
              drawBorder: false
            },
            ticks: {
              color: isDark ? '#9CA3AF' : '#6B7280',
              font: {
                size: 13,
                weight: 500
              },
              callback: function(value) {
                return Math.floor(value) === value ? value : null;
              }
            },
            border: {
              display: false
            }
          }
        }
      }
    });

    document.addEventListener('dark-mode', function() {
      const newIsDark = document.documentElement.classList.contains('dark');
      chart.options.plugins.tooltip.backgroundColor = newIsDark ? '#1F2937' : '#FFFFFF';
      chart.options.plugins.tooltip.titleColor = newIsDark ? '#F3F4F6' : '#111827';
      chart.options.plugins.tooltip.bodyColor = newIsDark ? '#D1D5DB' : '#6B7280';
      chart.options.plugins.tooltip.borderColor = newIsDark ? '#374151' : '#E5E7EB';
      chart.options.scales.x.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
      chart.options.scales.x.border.color = newIsDark ? '#374151' : '#E5E7EB';
      chart.options.scales.y.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
      chart.options.scales.y.grid.color = newIsDark ? '#374151' : '#F3F4F6';
      chart.update();
    });
  }

  // Renewals report: renewed / awaiting / lapsed per month due
  const renewalStatusChart = document.getElementById('renewal-status-chart');
  if (renewalStatusChart) {
    createStackedBarChart(renewalStatusChart, [
      { key: 'renewed', label: 'Renewed', color: '#16A34A' },
      { key: 'awaiting', label: 'Awaiting renewal', color: '#1C64F2' },
      { key: 'lapsed', label: 'Lapsed', color: '#D97706' }
    ]);
  }

  // Renewals report: income received per month by source
  const incomeChart = document.getElementById('income-chart');
  if (incomeChart) {
    createStackedBarChart(incomeChart, [
      { key: 'new_licences', label: 'New Licences', color: '#16BDCA' },
      { key: 'renewals', label: 'Renewals', color: '#7E3AF2' }
    ], { money: true });
  }
});

// Stacked bar chart from the canvas's data-chart JSON: { labels: [...], <series key>: [...] }
function createStackedBarChart(canvas, series, options = {}) {
  const data = JSON.parse(canvas.getAttribute('data-chart') || '{}');
  const isDark = document.documentElement.classList.contains('dark');
  const format = options.money
    ? (value) => '£' + Number(value).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : (value) => value;

  const chart = new Chart(canvas.getContext('2d'), {
    type: 'bar',
    data: {
      labels: data.labels || [],
      datasets: series.map((s) => ({
        label: s.label,
        data: data[s.key] || [],
        backgroundColor: s.color,
        borderRadius: 2,
        barPercentage: 0.6
      }))
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        mode: 'index',
        intersect: false
      },
      plugins: {
        legend: {
          display: true,
          position: 'top',
          align: 'start',
          labels: {
            usePointStyle: true,
            color: isDark ? '#9CA3AF' : '#6B7280',
            font: { size: 13, weight: 500, family: 'Inter, sans-serif' },
            padding: 15
          }
        },
        tooltip: {
          enabled: true,
          backgroundColor: isDark ? '#1F2937' : '#FFFFFF',
          titleColor: isDark ? '#F3F4F6' : '#111827',
          bodyColor: isDark ? '#D1D5DB' : '#6B7280',
          footerColor: isDark ? '#F3F4F6' : '#111827',
          borderColor: isDark ? '#374151' : '#E5E7EB',
          borderWidth: 1,
          padding: 12,
          callbacks: {
            label: (context) => context.dataset.label + ': ' + format(context.parsed.y),
            footer: (items) => 'Total: ' + format(items.reduce((sum, item) => sum + item.parsed.y, 0))
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          grid: { display: false },
          ticks: {
            color: isDark ? '#9CA3AF' : '#6B7280',
            font: { size: 11, weight: 500 },
            maxRotation: options.rotateLabels ? 45 : 0,
            minRotation: options.rotateLabels ? 45 : 0
          },
          border: { color: isDark ? '#374151' : '#E5E7EB' }
        },
        y: {
          stacked: true,
          beginAtZero: true,
          grid: { color: isDark ? '#374151' : '#F3F4F6', drawBorder: false },
          ticks: {
            color: isDark ? '#9CA3AF' : '#6B7280',
            font: { size: 13, weight: 500 },
            callback: (value) => options.money ? '£' + value : (Math.floor(value) === value ? value : null)
          },
          border: { display: false }
        }
      }
    }
  });

  document.addEventListener('dark-mode', function() {
    const newIsDark = document.documentElement.classList.contains('dark');
    chart.options.plugins.legend.labels.color = newIsDark ? '#9CA3AF' : '#6B7280';
    chart.options.plugins.tooltip.backgroundColor = newIsDark ? '#1F2937' : '#FFFFFF';
    chart.options.plugins.tooltip.titleColor = newIsDark ? '#F3F4F6' : '#111827';
    chart.options.plugins.tooltip.bodyColor = newIsDark ? '#D1D5DB' : '#6B7280';
    chart.options.plugins.tooltip.footerColor = newIsDark ? '#F3F4F6' : '#111827';
    chart.options.plugins.tooltip.borderColor = newIsDark ? '#374151' : '#E5E7EB';
    chart.options.scales.x.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
    chart.options.scales.x.border.color = newIsDark ? '#374151' : '#E5E7EB';
    chart.options.scales.y.ticks.color = newIsDark ? '#9CA3AF' : '#6B7280';
    chart.options.scales.y.grid.color = newIsDark ? '#374151' : '#F3F4F6';
    chart.update();
  });

  return chart;
}

const getMainChartOptions = () => {
    let mainChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
        mainChartColors = {
            borderColor: '#374151',
            labelColor: '#9CA3AF',
            opacityFrom: 0,
            opacityTo: 0.15,
        };
    } else {
        mainChartColors = {
            borderColor: '#F3F4F6',
            labelColor: '#6B7280',
            opacityFrom: 0.45,
            opacityTo: 0,
        }
    }

    return {
        chart: {
            height: 420,
            type: 'area',
            fontFamily: 'Inter, sans-serif',
            foreColor: mainChartColors.labelColor,
            toolbar: {
                show: false
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                enabled: true,
                opacityFrom: mainChartColors.opacityFrom,
                opacityTo: mainChartColors.opacityTo
            }
        },
        dataLabels: {
            enabled: false
        },
        tooltip: {
            style: {
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif',
            },
        },
        grid: {
            show: true,
            borderColor: mainChartColors.borderColor,
            strokeDashArray: 1,
            padding: {
                left: 35,
                bottom: 15
            }
        },
        series: [
            {
                name: 'Revenue',
                data: [6356, 6218, 6156, 6526, 6356, 6256, 6056],
                color: '#1A56DB'
            },
            {
                name: 'Revenue (previous period)',
                data: [6556, 6725, 6424, 6356, 6586, 6756, 6616],
                color: '#FDBA8C'
            }
        ],
        markers: {
            size: 5,
            strokeColors: '#ffffff',
            hover: {
                size: undefined,
                sizeOffset: 3
            }
        },
        xaxis: {
            categories: ['01 Feb', '02 Feb', '03 Feb', '04 Feb', '05 Feb', '06 Feb', '07 Feb'],
            labels: {
                style: {
                    colors: [mainChartColors.labelColor],
                    fontSize: '14px',
                    fontWeight: 500,
                },
            },
            axisBorder: {
                color: mainChartColors.borderColor,
            },
            axisTicks: {
                color: mainChartColors.borderColor,
            },
            crosshairs: {
                show: true,
                position: 'back',
                stroke: {
                    color: mainChartColors.borderColor,
                    width: 1,
                    dashArray: 10,
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: [mainChartColors.labelColor],
                    fontSize: '14px',
                    fontWeight: 500,
                },
                formatter: function (value) {
                    return '$' + value;
                }
            },
        },
        legend: {
            fontSize: '14px',
            fontWeight: 500,
            fontFamily: 'Inter, sans-serif',
            labels: {
                colors: [mainChartColors.labelColor]
            },
            itemMargin: {
                horizontal: 10
            }
        },
        responsive: [
            {
                breakpoint: 1024,
                options: {
                    xaxis: {
                        labels: {
                            show: false
                        }
                    }
                }
            }
        ]
    };
}

if (document.getElementById('pages-chart')) {
    const chart = new ApexCharts(document.getElementById('pages-chart'), getMainChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
        chart.updateOptions(getMainChartOptions());
    });
}

if (document.getElementById('new-products-chart')) {
    const options = {
        colors: ['#1A56DB', '#FDBA8C'],
        series: [
            {
                name: 'Digital',
                color: '#1A56DB',
                data: [
                    { x: '01 Feb', y: 170 },
                    { x: '02 Feb', y: 180 },
                    { x: '03 Feb', y: 164 },
                    { x: '04 Feb', y: 145 },
                    { x: '05 Feb', y: 174 },
                    { x: '06 Feb', y: 170 },
                    { x: '07 Feb', y: 155 },
                ]
            },
            {
                name: 'Goods',
                color: '#FDBA8C',
                data: [
                    { x: '01 Feb', y: 120 },
                    { x: '02 Feb', y: 134 },
                    { x: '03 Feb', y: 167 },
                    { x: '04 Feb', y: 179 },
                    { x: '05 Feb', y: 145 },
                    { x: '06 Feb', y: 182 },
                    { x: '07 Feb', y: 143 }
                ]
            }
        ],
        chart: {
            type: 'bar',
            height: '305px',
            fontFamily: 'Inter, sans-serif',
            foreColor: '#4B5563',
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '50%',
                borderRadius: 3
            }
        },
        tooltip: {
            shared: true,
            intersect: false,
            style: {
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif'
            },
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 1
                }
            }
        },
        stroke: {
            show: true,
            width: 5,
            colors: ['transparent']
        },
        grid: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
        xaxis: {
            floating: true,
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
        },
        yaxis: {
            show: false
        },
        fill: {
            opacity: 1
        }
    };

    const chart = new ApexCharts(document.getElementById('new-products-chart'), options);
    chart.render();
}

const getVisitorsChartOptions = () => {
    let visitorsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
        visitorsChartColors = {
            fillGradientShade: 'dark',
            fillGradientShadeIntensity: 0.45,
        };
    } else {
        visitorsChartColors = {
            fillGradientShade: 'light',
            fillGradientShadeIntensity: 1,
        }
    }

    return {
        series: [{
            name: 'Visitors',
            data: [500, 590, 600, 520, 610, 550, 600]
        }],
        labels: ['01 Feb', '02 Feb', '03 Feb', '04 Feb', '05 Feb', '06 Feb', '07 Feb'],
        chart: {
            type: 'area',
            height: '305px',
            fontFamily: 'Inter, sans-serif',
            sparkline: {
                enabled: true
            },
            toolbar: {
                show: false
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: visitorsChartColors.fillGradientShade,
                shadeIntensity: visitorsChartColors.fillGradientShadeIntensity
            },
        },
        plotOptions: {
            area: {
                fillTo: 'end'
            }
        },
        theme: {
            monochrome: {
                enabled: true,
                color: '#1A56DB',
            }
        },
        tooltip: {
            style: {
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif'
            },
        },
    }
}

if (document.getElementById('visitors-chart')) {
    const chart = new ApexCharts(document.getElementById('visitors-chart'), getVisitorsChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
        chart.updateOptions(getVisitorsChartOptions());
    });
}

const getSignupsChartOptions = () => {
    let signupsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
        signupsChartColors = {
            backgroundBarColors: ['#374151', '#374151', '#374151', '#374151', '#374151', '#374151', '#374151']
        };
    } else {
        signupsChartColors = {
            backgroundBarColors: ['#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB']
        };
    }

    return {
        series: [{
            name: 'Users',
            data: [34, 45, 53, 38, 55, 32, 36]
        }],
        labels: ['01 Feb', '02 Feb', '03 Feb', '04 Feb', '05 Feb', '06 Feb', '07 Feb'],
        chart: {
            type: 'bar',
            height: '305px',
            foreColor: '#4B5563',
            fontFamily: 'Inter, sans-serif',
            toolbar: {
                show: false
            }
        },
        theme: {
            monochrome: {
                enabled: true,
                color: '#1A56DB'
            }
        },
        plotOptions: {
            bar: {
                columnWidth: '25%',
                borderRadius: 3,
                colors: {
                    backgroundBarColors: signupsChartColors.backgroundBarColors,
                    backgroundBarRadius: 3
                },
            },
            dataLabels: {
                hideOverflowingLabels: false
            }
        },
        xaxis: {
            floating: true,
            labels: {
                show: false
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            style: {
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif'
            }
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 0.8
                }
            }
        },
        fill: {
            opacity: 1
        },
        yaxis: {
            show: false
        },
        grid: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
    };
}

if (document.getElementById('week-signups-chart')) {
    const chart = new ApexCharts(document.getElementById('week-signups-chart'), getSignupsChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
        chart.updateOptions(getSignupsChartOptions());
    });
}

const getTrafficChannelsChartOptions = () => {

    let trafficChannelsChartColors = {}

    if (document.documentElement.classList.contains('dark')) {
        trafficChannelsChartColors = {
            strokeColor: '#111827'
        };
    } else {
        trafficChannelsChartColors = {
            strokeColor: '#ffffff'
        }
    }

    return {
        series: [30, 24, 18, 12, 9, 7],
        labels: ['Organic', 'Referral', 'Direct', 'Social', 'Other', 'Email'],
        colors: ['#16BDCA', '#FDBA8C', '#1A56DB', '#D61F69', '#9061F9', '#6875F5'],
        chart: {
            type: 'donut',
            height: 305,
            fontFamily: 'Inter, sans-serif',
            toolbar: {
                show: false
            },
        },
        stroke: {
            colors: [trafficChannelsChartColors.strokeColor]
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '5%'
                }
            }
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 0.9
                }
            }
        },
        tooltip: {
            shared: true,
            followCursor: false,
            fillSeriesColor: false,
            inverseOrder: true,
            style: {
                fontSize: '14px',
                fontFamily: 'Inter, sans-serif'
            },
            x: {
                show: true,
                formatter: function (_, { seriesIndex, w }) {
                    const label = w.config.labels[seriesIndex];
                    return label
                }
            },
            y: {
                formatter: function (value) {
                    return value + '%';
                }
            }
        },
        grid: {
            show: false
        },
        dataLabels: {
            enabled: false
        },
        legend: {
            show: false
        },
    };
}

if (document.getElementById('traffic-channels-chart')) {
    const chart = new ApexCharts(document.getElementById('traffic-channels-chart'), getTrafficChannelsChartOptions());
    chart.render();

    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
        chart.updateOptions(getTrafficChannelsChartOptions());
    });
}
